<template>
  <div>
    <span class="d-flex align-items-start">
      <font-awesome-icon
        class=""
        :icon="['fas', isOnline ? '' : 'triangle-exclamation']"
        :class="{ icon: true, 'icon-red': !isOnline, 'icon-default': isOnline }"
      />
      <p
        :class="{
          'status-text': true,
          'status-online': isOnline,
          'status-offline': !isOnline,
        }"
      >
        <span v-if="isOnline" class="green-dot"></span>
        {{ isOnline ? "Online" : "Currently Offline..." }}
      </p>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOnline: false, // Start as offline until confirmed
      checkInterval: null, // Interval ID for periodic checks
    };
  },
  methods: {
    async checkConnectivity() {
      try {
        // Ping a reliable server (1.1.1.1) with a small fetch request
        const response = await fetch("https://dns.google/", {
          method: "HEAD",
          mode: "no-cors",
        });
        this.isOnline = response.ok || response.type === "opaque"; // Treat opaque responses as successful
      } catch (error) {
        this.isOnline = false; // Assume offline on error
      }
    },
    updateOnlineStatus() {
      if (navigator.onLine) {
        this.checkConnectivity();
      } else {
        this.isOnline = false;
      }
    },
    startConnectivityChecks() {
      // Perform an initial check
      this.updateOnlineStatus();

      // Set up periodic checks every 10 seconds
      this.checkInterval = setInterval(this.updateOnlineStatus, 10000);
    },
    stopConnectivityChecks() {
      // Clear the periodic check interval
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }
    },
  },
  created() {
    // Initial setup: Listen for network status changes and start periodic checks
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.startConnectivityChecks();
  },
  beforeDestroy() {
    // Clean up listeners and intervals
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
    this.stopConnectivityChecks();
  },
};
</script>

<style>
.icon {
  font-size: 1.5rem; /* Adjust size as needed */
}

.icon-red {
  color: red; /* Color for when offline */
}

.icon-default {
  color: inherit; /* Use default or parent text color */
}

.green-dot {
  display: inline-block;
  width: 15px;
  height: 15px;
  background-color: green;
  animation: wave 1s infinite ease-in-out;
  border-radius: 50%;
  margin-right: 5px;
}

.status-text {
  display: flex;
  align-items: center;
  margin-top: 3px;
  margin-bottom: -5px !important;
  padding-bottom: 0 !important;
  gap: 5px;
  font-weight: bold;
}

.status-online {
  color: white;
}

.status-offline {
  color: red;
}

.icon-red {
  animation: wave 1.5s infinite ease-in-out;
  color: red !important;
}

@keyframes wave {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.1);
  }
}
</style>
